import { CSSProperties, useEffect, useRef, useState } from 'react';
import './UniWidgetSummaryReportTwo.scss';
import ReactSpeedometer, { CustomSegmentLabel } from 'react-d3-speedometer';

export type UniWidgetSummaryReportTwoProps = {
    title: string,
    subtitle: string,
    iconImg: string,
    iconTotalImg: string,
    value: number,
    total: number,
    speedometerValue: number,
    speedometerSegmentColors?: string[],
    speedometerCustomSegmentLabels?: CustomSegmentLabel[],
    speedometerMinValue?: number,
    speedometerMaxValue?: number
};

const UniWidgetSummaryReportTwo = (props: UniWidgetSummaryReportTwoProps) => {
    const [dimensionsParent, setDimensionsParent] = useState({ width: 0, height: 0 });    

    const refParent = useRef<any>(null);

    useEffect(() => {
        const getDimensions = (ref: any) => ({
            width: ref.current.offsetWidth,
            height: ref.current.offsetHeight
        })

        const handleResize = () => {
            setDimensionsParent(getDimensions(refParent));
        }

        if (refParent.current) {
            setDimensionsParent(getDimensions(refParent));
        }        

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        }        
    }, [refParent]);

    const getSpeedometerWidth = () => {
        if(dimensionsParent.width < 290) {
            if(dimensionsParent.width - 90 <= 80) {
                return 0;
            }
            return dimensionsParent.width - 90;
        }
        return 200;
    }

    const getValueFontSize = () => {
        return getSpeedometerWidth() === 200 ? 40 : 24;
    }    

    const getIconSize = () => {
        return getSpeedometerWidth() === 200 ? 34 : 24;
    }
    
    return (
        <>
            <div className='uni-widget-summary-report-two'>
                <div className='uni-widget-summary-report-title'>
                    {props.title} - 
                    <span className='uni-widget-summary-report-subtitle'>{props.subtitle}</span>
                </div>
                <div ref={refParent} className='uni-widget-summary-report-body'>
                    <div className='uni-widget-summary-report-left'>
                        <div className='uni-widget-summary-report-icon'>
                            <img src={props.iconImg} alt='iconImg' style={{width: getIconSize(), height: getIconSize()}}/>
                            <span className='uni-widget-summary-report-value' style={{fontSize: getValueFontSize()}}>
                                {props.value}
                            </span>
                        </div>
                        <div className='uni-widget-summary-report-total-wrapper'>
                            <div className='uni-widget-summary-report-total'>
                                Total
                                <span>{props.total}</span>
                            </div>
                            <img src={props.iconTotalImg} alt='iconTotalImg' />
                        </div>
                    </div>
                    <div className='uni-widget-summary-report-right'>
                        <ReactSpeedometer                            
                            forceRender={true}
                            width={getSpeedometerWidth()}
                            height={105}
                            needleHeightRatio={0.8}
                            value={props.speedometerValue}
                            currentValueText=" "
                            segments={props.speedometerSegmentColors?.length}
                            minValue={props.speedometerMinValue}
                            maxValue={props.speedometerMaxValue}
                            segmentColors={props.speedometerSegmentColors}
                            customSegmentLabels={props.speedometerCustomSegmentLabels}
                            ringWidth={22}
                            needleColor={"#5A5A5A"}
                            needleTransitionDuration={0}
                            textColor={"#d8dee9"}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default UniWidgetSummaryReportTwo;